import { render, staticRenderFns } from "./GeoCopy.vue?vue&type=template&id=0f80c6cc&"
import script from "./GeoCopy.vue?vue&type=script&lang=ts&"
export * from "./GeoCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports